"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.lessonVisitInfoSchema = void 0;
const zod_1 = require("zod");
exports.lessonVisitInfoSchema = zod_1.z.object({
  is_author: zod_1.z.boolean(),
  is_liked: zod_1.z.boolean(),
  is_disliked: zod_1.z.boolean(),
  is_commented: zod_1.z.boolean(),
  is_passed: zod_1.z.boolean(),
  passed_at: zod_1.z.date(),
  pass_points: zod_1.z.number(),
  pass_percent: zod_1.z.number(),
  pass_game_id: zod_1.z.string(),
  selected_terms_count: zod_1.z.number().optional(),
  is_access_granted: zod_1.z.boolean().optional()
});
